import { ICommunication, ICommunicationData, ICommunicationReport } from './communication.types';
import { IWorkflowData, IWorkflowSteps, IParentChildWorkflowInfo } from '../common';

export class CommunicationData implements ICommunicationData {
    communication: ICommunication
    reports: Array<ICommunicationReport>
    currentStepId: string
    selectedKey: string   
    workflowData: IWorkflowData 
    grantInfo: any
    template: any
    guidelineDoc: string
    maxFileLimit: any
    workflowInfo: IParentChildWorkflowInfo
    selectedSteps: Array<string>
    workflowSteps: Array<IWorkflowSteps>

    constructor(comm: ICommunicationData) {
        this.communication = comm.communication || {} as ICommunication;
        this.reports = comm.reports || [];
        this.selectedKey = comm.selectedKey || "summary";
        this.grantInfo = comm.grantInfo || {};
        this.template = comm.template;
        this.currentStepId = comm.currentStepId;
        this.workflowData = comm.workflowData || {} as IWorkflowData;
        this.guidelineDoc = comm.guidelineDoc || '';
        this.maxFileLimit = comm.maxFileLimit || 5;
        this.workflowInfo = comm.workflowInfo
        this.selectedSteps = comm.selectedSteps || [];
        this.workflowSteps = comm.workflowSteps || [];
    }
}

export class Communication implements ICommunication {
    GrantCommunicationId: number
    GrantId: number
    InitiativeCallId: number
    ProgramId: number
    Steps: any
    StartDate: Date
    EndDate: Date
    WorkflowInstanceId: string
    WorkflowData: string
    WorkFlowStatusId: number
    CreatedById: string
    CreatedDate: Date
    OriginInitiativeId: number

    constructor(comm: ICommunication) {
        this.GrantCommunicationId = comm.GrantCommunicationId;
        this.GrantId = comm.GrantId;
        this.InitiativeCallId = comm.InitiativeCallId;
        this.ProgramId = comm.ProgramId;
        this.Steps = comm.Steps || {};
        this.StartDate = comm.StartDate;
        this.EndDate = comm.EndDate;
        this.WorkflowInstanceId = comm.WorkflowInstanceId;
        this.WorkflowData = comm.WorkflowData;
        this.WorkFlowStatusId = comm.WorkFlowStatusId;
        this.CreatedById = comm.CreatedById;
        this.CreatedDate = comm.CreatedDate;
        this.OriginInitiativeId = comm.OriginInitiativeId
    }
}

export class Communicationreport implements ICommunicationReport {
    CommunicationReportId: number
    GrantCommunicationId: number
    ProgramId: number
    StepId: string
    Description: string
    StartDate: Date
    EndDate: Date
    ExtendedDate: Date
    Status: number
    GranteeId: number
    ProgramOfficerId: number
    ReportData: any

    constructor(report: ICommunicationReport) {
        this.CommunicationReportId = report.CommunicationReportId;
        this.GrantCommunicationId = report.GrantCommunicationId;
        this.ProgramId = report.ProgramId;
        this.StepId = report.StepId;
        this.Description = report.Description;
        this.StartDate = report.StartDate;
        this.EndDate = report.EndDate;
        this.ExtendedDate = report.ExtendedDate;
        this.Status = report.Status;
        this.GranteeId = report.GranteeId;
        this.ProgramOfficerId = report.ProgramOfficerId;
        this.ReportData = report.ReportData;
    }
}